export const actions = {
  FETCH_NOTIFICATIONS: 'FETCH_NOTIFICATIONS',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
}

// set notification
export const allNotifications = (data) => {
  return {
    type: 'SET_NOTIFICATIONS',
    payload: data,
  }
}
